import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@shared/lib/http/axiosBaseQuery";
import { TicketHebType } from "@models/types";
import { Account, AccountsPaginatedSchema } from "@models/account";

export const accountsApi = createApi({
  reducerPath: "accountsApi",
  baseQuery: axiosBaseQuery({ baseUrl: "/api/" }),
  tagTypes: ["accounts"],
  endpoints: (b) => ({
    getAccountsByType: b.query<Account[], TicketHebType>({
      query: (accountHebType) => ({
        url: "accounts/search",
        method: "POST",
        data: {
          filter: { account_type: accountHebType },
          include: "customData,entries.document.documentSettings",
          sort: "id",
          per_page: 100,
        },
      }),
      transformResponse: (response: unknown) =>
        AccountsPaginatedSchema.parse(response).data,
      providesTags: (_res, _err, accountHebType) => [{ type: "accounts", id: accountHebType }],
      keepUnusedDataFor: Infinity,
    }),
  }),
});

export const { useGetAccountsByTypeQuery, useLazyGetAccountsByTypeQuery } = accountsApi;

export const useGetIncomesAccountsQuery = () => accountsApi.useGetAccountsByTypeQuery("הכנסה");

export const useGetOutcomesAccountsQuery = () => accountsApi.useGetAccountsByTypeQuery("הוצאה");

export const useGetBanksAccountsQuery = () => accountsApi.useGetAccountsByTypeQuery("בנק");

export const useGetCashBoxesAccountsQuery = () => accountsApi.useGetAccountsByTypeQuery("קופה");

export const useGetSystemAccountsQuery = () => accountsApi.useGetAccountsByTypeQuery("מערכת");
